import { createSlice } from '@reduxjs/toolkit';

const initialState =
	localStorage.getItem('planificacionDisplayDate') === null
		? false
		: localStorage.getItem('planificacionDisplayDate') === 'true';

const planificacionDisplayDateSlice = createSlice({
	name: 'planificacionDisplayDate',
	initialState,
	reducers: {
		changeDisplayDate: (state, action) => {
			const show = action.payload === true;
			localStorage.setItem('planificacionDisplayDate', show ? 'true' : 'false');
			return action.payload;
		}
	}
});

export const { changeDisplayDate } = planificacionDisplayDateSlice.actions;
export default planificacionDisplayDateSlice.reducer;
